import styled from 'styled-components';

export const List = styled.ul<{ $invertVerticalPadding?: boolean }>`
  display: grid;
  gap: ${({ theme }) => theme.spacing(1)};

  padding: ${({ theme, $invertVerticalPadding }) =>
    `${theme.spacing($invertVerticalPadding ? 2 : 0)} ${theme.spacing(3)} ${theme.spacing($invertVerticalPadding ? 2.5 : 2)}`};
  margin: 0;

  list-style: none;
`;

export const ListItem = styled.li<{
  $horizontalPadding?: boolean;
  $verticalPadding?: boolean;
}>`
  padding: ${({ theme, $horizontalPadding, $verticalPadding }) =>
    `${$verticalPadding ? theme.spacing(1) : 0} ${$horizontalPadding ? theme.spacing(2) : 0}`};
  min-width: 0;
`;

export const ListDivider = styled.span`
  display: block;
  margin: ${({ theme }) => `0 ${theme.spacing(2)}`};
  width: calc(100% - ${({ theme }) => theme.spacing(4)});
  height: 1px;
  background: ${({ theme }) => theme.palette.grey[400]};
`;

export const Divider = styled.span`
  display: block;
  margin: ${({ theme }) => `0 ${theme.spacing(5)}`};
  width: calc(100% - ${({ theme }) => theme.spacing(10)});
  height: 1px;
  background: ${({ theme }) => theme.palette.grey[400]};
`;
